import React, { useState } from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import DownloadAppSection from '../components/DownloadAppSection';
import AppCarousel from '../components/AppCarousel';
import { getAppleStoreUrl, getGooglePlayUrl } from '../utils/storeLinks';
import '../styles/App.css';
import '../styles/Content.css';
import '../styles/AppPage.css';
import AppleIcon from '../assets/icons/apple.svg';
import GooglePlayIcon from '../assets/icons/google-play.svg';

// iOS & Android section images (dashboard) – dark/light
import iPhoneDashboardDark from '../assets/images/app/phones/iPhone_dashboard_dark.png';
import iPhoneDashboardLight from '../assets/images/app/phones/iPhone_dashboard_light.png';
import AndroidDashboardDark from '../assets/images/app/phones/Android_dashboard_dark.png';
import AndroidDashboardLight from '../assets/images/app/phones/Android_dashboard_light.png';

// Carousel: dashboard, start-workout, workout, complete-workout, stats, calendar
import iPhoneStartWorkoutD from '../assets/images/app/phones/iPhone_start-workout_dark.png';
import iPhoneStartWorkoutL from '../assets/images/app/phones/iPhone_start-workout_light.png';
import iPhoneWorkoutD from '../assets/images/app/phones/iPhone_workout_dark.png';
import iPhoneWorkoutL from '../assets/images/app/phones/iPhone_workout_light.png';
import iPhoneCompleteWorkoutD from '../assets/images/app/phones/iPhone_complete-workout_dark.png';
import iPhoneCompleteWorkoutL from '../assets/images/app/phones/iPhone_complete-workout_light.png';
import iPhoneStatsD from '../assets/images/app/phones/iPhone_stats_dark.png';
import iPhoneStatsL from '../assets/images/app/phones/iPhone_stats_light.png';
import iPhoneCalendarD from '../assets/images/app/phones/iPhone_calendar_dark.png';
import iPhoneCalendarL from '../assets/images/app/phones/iPhone_calendar_light.png';

const CAROUSEL_DARK = [
  iPhoneDashboardDark,
  iPhoneStartWorkoutD,
  iPhoneWorkoutD,
  iPhoneCompleteWorkoutD,
  iPhoneStatsD,
  iPhoneCalendarD,
];
const CAROUSEL_LIGHT = [
  iPhoneDashboardLight,
  iPhoneStartWorkoutL,
  iPhoneWorkoutL,
  iPhoneCompleteWorkoutL,
  iPhoneStatsL,
  iPhoneCalendarL,
];

function App() {
  const [theme, setTheme] = useState('dark');
  const isLight = theme === 'light';

  const iosImage = isLight ? iPhoneDashboardLight : iPhoneDashboardDark;
  const androidImage = isLight ? AndroidDashboardLight : AndroidDashboardDark;
  const carouselSlides = isLight ? CAROUSEL_LIGHT : CAROUSEL_DARK;

  return (
    <div className="home">
      <SEO
        title="Download Begin Strength"
        description="Download the Begin Strength app for iOS and Android. Track workouts, follow programs, and build strength."
        image="/og-images/programs.png"
        path="/app"
      />
      <Header />
      <main className="app-page">
        <header className="app-page-header">
          <h2 className="content-header">
            Download <span style={{ color: 'red' }}>Begin Strength</span>
          </h2>
          <p className="content-description">
            iOS and Android. Your programs, periodization, and performance tracking—wherever you train.
          </p>
          <div className="app-page-toggle-wrap">
            <span className={theme === 'dark' ? 'app-page-toggle-label active' : 'app-page-toggle-label'}>Dark</span>
            <button
              type="button"
              className="app-page-toggle"
              role="switch"
              aria-checked={isLight}
              aria-label="Switch to light or dark app previews"
              onClick={() => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))}
            >
              <span className="app-page-toggle-thumb" />
            </button>
            <span className={theme === 'light' ? 'app-page-toggle-label active' : 'app-page-toggle-label'}>Light</span>
          </div>
        </header>

        <div className="app-platform-container">
        <DownloadAppSection
          title={<><span style={{ color: 'red' }}>iOS</span></>}
          copy="Begin Strength on iPhone and iPad. Your dashboard, programs, periodization, and performance tracking—built for Apple devices."
          imageSrc={iosImage}
          imageOn="right"
        >
          <a
            href={getAppleStoreUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="download-button-apple"
          >
            <img src={AppleIcon} alt="Apple" />
            <div className="download-button-text">
              <span className="download-button-text-top">Download on the</span>
              <span className="download-button-text-bottom">App Store</span>
            </div>
          </a>
        </DownloadAppSection>
        </div>

        <div className="app-platform-container">
        <DownloadAppSection
          title={<><span style={{ color: 'red' }}>Android</span></>}
          copy="Begin Strength on Android. The same programs, periodization, and tracking—wherever you train."
          imageSrc={androidImage}
          imageOn="left"
        >
          <a
            href={getGooglePlayUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="download-button"
          >
            <img src={GooglePlayIcon} alt="Google Play" />
            <div className="download-button-text">
              <span className="download-button-text-top">GET IT ON</span>
              <span className="download-button-text-bottom">Google <strong>Play</strong></span>
            </div>
          </a>
        </DownloadAppSection>
        </div>

        <AppCarousel slides={carouselSlides} />
      </main>
      <Footer />
    </div>
  );
}

export default App;
